export default {
  submitText: '退费',
  emptyBtn: false,
  column: [
    {
      label: 'id',
      display: false,
      prop: 'id',
      span: 8,
    },
    {
      label: '车场名称',
      type: 'tree',
      prop: 'spaceId',
      span: 8,
      editDisabled: true,
      disabled: true,
      cell: true,
      props: {
        label: 'title',
        value: 'key',
      },
      dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
    },
    {
      label: '车牌号',
      disabled: true,
      prop: 'carNo',
      span: 8,
    },
    {
      label: '车辆类型',
      editDisabled: true,
      span: 8,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=car_type',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      prop: 'carType',
      search: true,
      disabled: true,
    },
    {
      label: '租赁起期',
      prop: 'buyStartTime',
      span: 8,
      type: 'date',
      format: 'yyyy-MM-dd 00:00:00',
      valueFormat: 'yyyy-MM-dd 00:00:00',
      editDisabled: true,
      disabled: true,
      rules: [
        {
          message: '请输入租赁止期',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收费套餐',
      prop: 'ruleName',
      span: 8,
      disabled: true,
    },

    {
      label: '租赁止期',
      prop: 'buyEndTime',
      type: 'date',
      format: 'yyyy-MM-dd 23:59:59',
      valueFormat: 'yyyy-MM-dd hh:mm:ss',
      span: 8,
      rules: [
        {
          required: true,
          message: '请输入租赁止期',
          trigger: 'change',
        },
      ],
    },
    {
      label: '应收金额',
      prop: 'shouldMoney',
      precision: 2,
      mock: {
        type: 'number',
        max: 1,
        min: 2,
        precision: 2,
      },
      minRows: 0.01,
      span: 8,
      disabled: true,
      rules: [
        {
          required: false,
          message: '请输入应收金额',
          trigger: 'change',
        },
      ],
    },
    {
      label: '优惠金额',
      hide: true,
      disabled: true,
      prop: 'cutMoney',
      span: 8,
      precision: 2,
      mock: {
        type: 'number',
        max: 1,
        min: 2,
        precision: 2,
      },
      minRows: 0.01,
    },
    {
      label: '支付金额',
      prop: 'payMoney',
      span: 8,
      disabled: true,
      precision: 2,
      mock: {
        type: 'number',
        max: 1,
        min: 2,
        precision: 2,
      },
      minRows: 0.01,
      rules: [
        {
          required: false,
          message: '请输入应收金额',
          trigger: 'change',
        },
      ],
    },
    {
      label: '支付方式',
      hide: true,
      prop: 'payType',
      disabled: true,
      span: 8,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      rules: [
        {
          required: false,
          message: '请输入支付方式',
          trigger: 'change',
        },
      ],
    },
    {
      label: '客户姓名',
      span: 8,
      search: true,
      prop: 'customerName',
      disabled: true,
      rules: [
        {
          message: '请输入客户姓名',
          trigger: 'change',
        },
      ],
    },
    {
      label: '客户手机',
      prop: 'customerPhone',
      disabled: true,
      span: 8,
      search: true,
      rules: [
        {
          message: '请输入客户手机号',
          trigger: 'change',
        },
      ],
    },

    {
      label: '状态',
      prop: 'status',
      display: false,
    },
    {
      label: '操作',
      prop: 'operateType',
      display: false,
    },

    {
      label: '车位编号',
      prop: 'lotNo',
      hide: true,
      span: 8,
      rules: [
        {
          required: false,
          message: '请输入停车车位编号',
          trigger: 'change',
        },
      ],
    },
    {
      label: '房间名称',
      prop: 'areaName',
      disabled: true,
      hide: true,
      span: 16,

      rules: [
        {
          required: false,
          message: '请输入房间名称',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退费金额',
      hide: true,
      prop: 'returnMoney',
      type: 'number',
      precision: 2,
      mock: {
        type: 'number',
        max: 1,
        min: 2,
        precision: 2,
      },
      minRows: 0.0,
      span: 8,
      rules: [
        {
          required: true,
          message: '请输入支付方式',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退费说明',
      prop: 'remark3',
      hide: true,
      span: 16,
      type: 'textarea',
      minRows: 2,
      maxlength: 100,
      showWordLimit: true,
      overHidden: true,
      rules: [
        {
          required: false,
          message: '请输入退费说明,预计三个工作日内完成退款',
          trigger: 'change',
        },
      ],
    },
  ],
};
